import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import Page from '../containers/page';

import PageForm from '../components/forms/pageForm';
import BlogForm from '../components/forms/blogForm';
import LocationForm from '../components/forms/locationForm';
import VideoForm from '../components/forms/videoForm';
import DocumentForm from '../components/forms/documentForm';
import PerformerForm from '../components/forms/performerForm';
import EventForm from '../components/forms/eventsForm';
import GalleryPage from '../components/forms/galleryForm';
import GamePage from '../components/forms/gameForm';
import HomePage from '../components/forms/homeForm';

import {
    Container,
    Row,
    Col,
} from 'reactstrap';
import SeoForm from '../components/forms/seoForm';


const forms = {
    'services': PageForm,
    'blog': BlogForm,
    'seo': SeoForm,
    'locations': LocationForm,
    'video': VideoForm,
    'documents': DocumentForm,
    'performers': PerformerForm,
    'events': EventForm,
    'gallery': GalleryPage,
    'games': GamePage,
    'homePage' : HomePage,


}

class AddPagePage extends Component {
    constructor(props) {
        super(props);
        this.addPage = this.addPage.bind(this);

        this.state = {
            projectsCategories: [],
            blogCategories: [],
            pages: []
        };
    }

    addPage(data) {
        console.log(data);
        if (data.date) {
            data.date = Math.floor(data.date.getTime() / 1000);
        }
        if (this.props[0].match.params.collection == "performers") {
            if (data.performance) {
                for (let i = 0; i < data.performance.length; i++) {
                    if (data.performance[i].date) {
                        data.performance[i].date = Math.floor(data.performance[i].date.getTime() / 1000);
                    }
                }
            }

        }
        // https://api.freedommusic.rs
        fetch('https://api.freedommusic.rs/admin/updateOne/' + this.props[0].match.params.collection + '/' + this.props[0].match.params.id, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify(data)
        }).then((res) => res.json()).then((result) => {
            this.props[0].history.push('/collection/' + this.props[0].match.params.collection)
        })
    }

    componentDidMount() {
        if (this.props[0].match.params.id != 'new') {
            fetch('https://api.freedommusic.rs/admin/fetchOne/' + this.props[0].match.params.collection + '/' + this.props[0].match.params.id, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`

                }
            }).then((res) => res.json()).then((result) => {
                if (result.date) {
                    console.log(result.date);
                    result.date = new Date(result.date * 1000);
                    console.log(result.date);
                }
                if (this.props[0].match.params.collection == "performers") {
                    if (result.performance) {
                        for (let i = 0; i < result.performance.length; i++) {
                            if (result.performance[i].date) {
                                result.performance[i].date = new Date(result.performance[i].date * 1000);
                            }
                        }
                    }

                }
                this.setState({
                    initialValues: result
                })
                console.log(result);
            })
        }
        if (this.props[0].match.params.collection == 'gallery' || this.props[0].match.params.collection == 'performers') {
            fetch('https://api.freedommusic.rs/admin/fetch/events', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
            }).then((res) => res.json()).then((result) => {
                console.log(result);
                this.setState({
                    events: result
                })
            })
        }




        fetch('https://api.freedommusic.rs/admin/fetch/pages', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
        }).then((res) => res.json()).then((result) => {
            console.log(result);
            this.setState({
                pages: result
            })
        })

    }


    render() {
        if (!this.props[0].match.params.collection) {
            return null;
        }
        const Form = forms[this.props[0].match.params.collection];
        return (

            <div className="page-wrap">
                {
                    !localStorage.token ? <Redirect to='/login' /> : null
                }

                <Container fluid>

                    <Row className="page-title">
                        <Col lg="12">
                            {this.props[0].match.params.id !== 'new' ? <h3>Izmjeni</h3> : <h3>Dodaj</h3>}
                        </Col>

                    </Row>

                    {this.state.initialValues ?
                        <Form blogCategories={this.state.blogCategories} events={this.state.events ? this.state.events : null} projectsCategories={this.state.projectsCategories} pages={this.state.pages} lang={this.props.lang} collection={this.props[0].match.params.collection} initialValues={this.state.initialValues} onSubmit={this.addPage} />
                        :
                        <Form blogCategories={this.state.blogCategories} events={this.state.events ? this.state.events : null} projectsCategories={this.state.projectsCategories} pages={this.state.pages} lang={this.props.lang} collection={this.props[0].match.params.collection} onSubmit={this.addPage} />
                    }
                </Container>


            </div>
        );
    }
}

export default Page(AddPagePage);